import * as types from './types';
import { actionCreator } from '@bit/wavfichacerta.fichacerta.utils.redux-utils';

export const openModal = (payload) => actionCreator(types.OPEN_MODAL, payload);
export const closeModal = () => actionCreator(types.CLOSE_MODAL);
export const openImportantFieldsModal = (payload) => actionCreator(types.OPEN_IMPORTANT_FIELDS_MODAL, payload);
export const closeImportantFieldsModal = () => actionCreator(types.CLOSE_IMPORTANT_FIELDS_MODAL);
